import React, { useState } from 'react';

import formatNumberWithCurrency from '@eika-infrastruktur/format/dist/formatNumberWithCurrency';

import type { Account, AccountNotification } from '../../../../generated-types';
import useTranslation, { formatJsx } from '../../../../hooks/useTranslation';
import AccountTransactionActiveToggleContent from './AccountTransactionActiveToggleContent';

type Props = {
    notification: AccountNotification;
    isLoading: boolean;
    removeNotification: (targetNotification: AccountNotification) => Promise<void>;
    targetAccount: Account | undefined;
};

const AccountTransactionActiveToggle: React.FC<Props> = ({
    notification,
    isLoading,
    removeNotification,
    targetAccount,
}) => {
    const translation = useTranslation();
    const areYouSureState = useState(false);

    if (
        notification.type === 'DEPOSIT_TYPE' ||
        notification.type === 'PAYMENT_FAILED' ||
        notification.type === 'BALANCE_PERIODIC_REPORT'
    )
        return null;

    const { title, text } = translation.pushNotifications.accountSpecificNotifications[notification.type];
    return (
        <li className="account-transaction-notification-settings__active-toggle-item">
            <article className="account-transaction-notification-settings__active-toggle-button">
                <AccountTransactionActiveToggleContent
                    id={String(notification.id)}
                    title={title}
                    isLoading={isLoading}
                    removeNotification={() => removeNotification(notification)}
                    areYouSureState={areYouSureState}
                >
                    {formatJsx(
                        text,
                        <span className="semibold">{targetAccount?.alias ?? notification.accountNo.value}</span>,
                        <span className="semibold">
                            {formatNumberWithCurrency(notification.amount ?? 0, 'NOK', 0)}
                        </span>,
                    )}
                </AccountTransactionActiveToggleContent>
            </article>
        </li>
    );
};

export default AccountTransactionActiveToggle;
